import {
  DeliveryMethodsTypes,
  IShippingSettings,
} from "@/api/AppApi/services/company/interfaces/ICompany";

export const createDelivery_methods = (
  shipingSettings: IShippingSettings,
): DeliveryMethodsTypes[] => {
  const delivery_methods = new Array<DeliveryMethodsTypes>();
  const isNeedToShowDelivery =
    shipingSettings?.enable_shipping ||
    shipingSettings?.shipping_not_available_message;
  const isNeedToShowPickup =
    shipingSettings?.enable_pickup ||
    shipingSettings?.pickup_not_available_message;
  if (isNeedToShowPickup) delivery_methods.push(DeliveryMethodsTypes.pickup);
  if (isNeedToShowDelivery)
    delivery_methods.push(DeliveryMethodsTypes.delivery);
  return delivery_methods;
};

export const initDeliveryMethods = (
  deliveryMethods: DeliveryMethodsTypes[],
): DeliveryMethodsTypes[] => {
  const currentDeliveryMethods = deliveryMethods?.filter(
    (method) =>
      method !== DeliveryMethodsTypes.dining_in &&
      method !== DeliveryMethodsTypes.online,
  );
  return currentDeliveryMethods;
};
